module.exports = __webpack_public_path__ + "img/fan_color.6f4a0cf6.gif";